import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { CookieService } from '../../services/cookie.service';
import * as momentNs from 'moment';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { TransformObjectFormService } from '../../utils/transform-object-form/transform-object-form.service';
import * as _ from 'underscore';

import { NumericalValidator } from '../../validator/numerical/numerical.validator';
import { NoSpaceValidator } from '../../validator/no-space/no-space.validator';
import'rxjs/add/operator/map';
import { NoNumericValidator } from '../../validator/no-numeric/no-numeric.validator';
import { transformKtpData } from '../../utils/input-handler/transform-ktp-data';
import { NoDashValidator } from '../../validator/no-dash/no-dash.validator';
import { RequiredSelectValidator } from '../../validator/required-select/required-select.validator';
import {
  BUSINESS_PROMOTION_ENTREPRENEUR,
  BUSINESS_PLACE_ENTREPRENEUR,
  NUMBER_OF_EMPLOYEES_ENTREPRENEUR,
} from '../../shared/constants/loan-form-entrepreneur.constant';
import { checkValInArrayObj } from '../../validator/check-value-in-array-object/check-value-in-array-object.validators';
import { numberDelimiter } from '../../utils/input-handler/number-delimiter';
import { removeDelimiter } from '../../utils/input-handler/remove-delimiter';
import { transformPhoneNumber } from '../../utils/transform-value/transfrom-phone-number';
import { AuthTokenService } from '../../services/authToken.service';
import { TNK_TOKEN } from '../../shared/constants/cookies-name.constant';
import { TNKLoanForm, InitRegions, DataRegions } from './auth-loan-form.model';
import { MAINTENANCE_ROUTE } from '../../shared/constants/route-url.constant';
import {
  POST_LOAN_ENVIRONMENT,
  ENTREPRENEUR_LOAN_TYPE,
  JOB_TYPE,
  POST_LOAN_VERSION,
} from '../../shared/constants/loan-form-data.constant';

const /** @type {?} */ moment = momentNs;
export class TNKAuthLoanFormService {
public data: Observable<TNKLoanForm>;
public isFraudAttemptAlert: boolean = false;
private dispatcher: BehaviorSubject<TNKLoanForm>;
private store: TNKLoanForm;
public obsInitRegions: Observable<InitRegions>;
private dispatcherInitRegions: BehaviorSubject<InitRegions>;
private initRegions: InitRegions;
private formData: any;
public contactSameAsKTP: boolean;
public cashtreeRefcodeFormat: string = 'CASHTR';
public currencyOptions: any;
private affiliateCookieName: string = 'TNK-AFFILIATE-CALLBACK';
public transformKtpData: any = transformKtpData;
/**
 * @param {?} fb
 * @param {?} http
 * @param {?} apiConstant
 * @param {?} router
 * @param {?} transformObject
 * @param {?} cookieService
 * @param {?} authService
 */
constructor(
private fb: FormBuilder,
private http: HttpClient,
private apiConstant: ApiConstant,
private router: Router,
private transformObject: TransformObjectFormService,
private cookieService: CookieService,
private authService: AuthTokenService,
  ) {
    this.currencyOptions = {
      prefix: '',
      thousands: '.',
      decimal: ',',
      align: 'left',
      precision: 0,
      allowZero: true,
    };

    this.initRegions = {
      isRegionsDomicileFetched: false,
      isRegionsContactFetched: false,
      isError: false,
    };

    this.store = {
      banks: [],
      birthCities: [],
      step: 1,
      accessToken: null,
      errors: {
        name: '',
        emailAddress: '',
        mobilePhoneNumber: '',
        mediasource: '',
        pin: '',
        bankName: '',
        bankAccount: '',
        educationType: '',
        ktpName: '',
        birthCityId: '',
        birthCityName: '',
        birthProvinceId: '',
        birthProvinceName: '',
        dateOfBirth: '',
        gender: '',
        domicileAddress_street: '',
        domicileAddress_bldNumber: '',
        domicileAddress_buildingType: '',
        domicileAddress_flatNumber: '',
        domicileAddress_rt: '',
        domicileAddress_rw: '',
        domicileAddress_province: '',
        domicileAddress_city: '',
        domicileAddress_district: '',
        domicileAddress_village: '',
        domicileAddress_postalCode: '',
        religion: '',
        citizenship: '',
        housing_propertyType: '',
        housing_residentialType: '',
        housing_monthlyCost: '',
        housing_expenseCost: '',
        housing_numberOfPeople: '',
        dependants: '',
        mothersName: '',
        contactAddress_province: '',
        contactAddress_city: '',
        contactAddress_district: '',
        contactAddress_village: '',
        contactAddress_postalCode: '',
        contactAddress_street: '',
        contactAddress_bldNumber: '',
        contactAddress_flatNumber: '',
        contactAddress_rt: '',
        contactAddress_rw: '',
        income_jobType: '',
        income_taxId: '',
        income_employeeId: '',
        income_employmentStatus: '',
        income_employerName: '',
        income_workPosition: '',
        income_monthlyIncome: '',
        income_previousIncome: '',
        income_businessName: '',
        income_businessType: '',
        income_businessAge: '',
        income_businessIncome: '',
        income_businessPromotion: '',
        income_businessPlace: '',
        income_numberOfEmployees: '',
        maritalStatusType: '',
        spouse_pin: '',
        spouse_name: '',
        spouse_dateOfBirth: '',
        spouse_splitAssetAgreement: '',
        personalReference_name: '',
        personalReference_mobilePhone: '',
        personalReference_homePhone: '',
        personalReference_address: '',
        referralCode: '',
        agreedForm: false,
      },
      disabledNextButton: true,
      serviceAreaIncluded: 'null',
      actionBusy: false,
      provinces: [],
      cities: [],
      districts: [],
      villages: [],
      postal_codes: [],
      showStep5Form: false,
      PINDataConfirmationBlock: false,
      oldVal_dob: '',
      oldVal_gender: '',
      doubleKTP: false,
      loadingKTP: true,
      cookiesData: null,
      editReviewForm: false,
      submitBusy: false,
      successCallbackURI: '',
      errorServerCallbackURI: '',
      busyServerCallbackURI: '',
      stepURI: [],
      showActionButton: true,
      debug: false,
      villagesContact: [],
      citiesContact: [],
      postalCodesContact: [],
      districtsContact: [],
      additionalParameter: '',
      contactAddress_provinceId: '',
      contactAddress_cityId: '',
      contactAddress_districtId: '',
      contactAddress_villageId: '',
      domicileAddress_provinceId: '',
      domicileAddress_cityId: '',
      domicileAddress_districtId: '',
      domicileAddress_villageId: '',
      isFraudAttemptAlert: false,
    };

    this.dispatcher = <BehaviorSubject<TNKLoanForm>>new BehaviorSubject({});
    this.data = this.dispatcher.asObservable();

    this.dispatcherInitRegions = <BehaviorSubject<InitRegions>>(
      new BehaviorSubject({})
    );
    this.obsInitRegions = this.dispatcherInitRegions.asObservable();
  }
public validationMessages: any = {
    name: {
      required: 'Nama lengkap wajib diisi',
      maxlength: 'Nama lengkap maksimal 50 karakter',
    },
    emailAddress: {
      required: 'Alamat email wajib diisi',
      email: 'Format email tidak sesuai',
    },
    mobilePhoneNumber: {
      required: 'Nomor handphone wajib diisi',
      numerical: 'Nomor handphone hanya diperbolehkan angka',
      maxlength: 'Nomor handphone maksimal 13 karakter',
      minlength: 'Nomor handphone minimal 9 karakter',
      customMobilePhoneNumber: 'Format Nomor Handphone tidak sesuai',
    },
    mediasource: {
      requiredSelect: 'Sumber media wajib diisi',
    },
    pin: {
      required: 'Nomor KTP wajib diisi',
      numerical: 'Nomor KTP hanya diperbolehkan angka',
      maxlength: 'Nomor KTP maksimal 16 karakter',
      minlength: 'Nomor KTP minimal 16 karakter',
    },
    bankName: {
      requiredSelect: 'Nama bank wajib diisi',
      noMatchValue: 'Nama bank tidak terdaftar',
    },
    bankAccount: {
      required: 'Nomor rekening wajib diisi',
      numerical: 'Nomor rekening hanya diperbolehkan angka',
      minlength: 'Nomor rekening minimal 5 karakter',
      maxlength: 'Nomor rekening maksimal 30 karakter',
    },
    educationType: {
      requiredSelect: 'Pendidikan terakhir wajib diisi',
    },
    ktpName: {
      required: 'Nama sesuai KTP wajib diisi',
      maxlength: 'Nama sesuai KTP maksimal 50 karakter',
    },
    birthCityName: {
      requiredSelect: 'Kota kelahiran wajib dipilih',
    },
    birthProvinceName: {
      requiredSelect: 'Provinsi tempat kelahiran wajib dipilih',
    },
    dateOfBirth: {
      required: 'Tanggal lahir wajib diisi',
    },
    gender: {
      requiredSelect: 'Jenis kelamin wajib diisi',
    },
    domicileAddress_street: {
      required: 'Alamat KTP wajib diisi',
      maxlength: 'Alamat KTP maksimal 100 karakter',
      minlength: 'Alamat KTP minimal 2 karakter',
    },
    domicileAddress_bldNumber: {
      required: 'Nomor blok wajib diisi',
      maxlength: 'Nomor blok maksimal 5 karakter',
      alphaNumeric: 'Nomor blok tidak diperbolehkan "-"',
    },
    domicileAddress_buildingType: {
      requiredSelect: 'Jenis tempat tinggal wajib dipilih',
    },
    domicileAddress_flatNumber: {
      required: 'Nomor rumah wajib diisi',
      maxlength: 'Nomor rumah maksimal 5 karakter',
      alphaNumeric: 'Nomor rumah tidak diperbolehkan "-"',
    },
    domicileAddress_rt: {
      required: 'RT wajib diisi',
      numerical: 'RT hanya diperbolehkan angka',
      maxlength: 'RT maksimal 3 karakter',
    },
    domicileAddress_rw: {
      required: 'RW wajib diisi',
      numerical: 'RW hanya diperbolehkan angka',
      maxlength: 'RW maksimal 3 karakter',
    },
    domicileAddress_province: {
      requiredSelect: 'Provinsi wajib diisi',
    },
    domicileAddress_city: {
      requiredSelect: 'Kota wajib diisi',
    },
    domicileAddress_district: {
      requiredSelect: 'Kecamatan wajib diisi',
    },
    domicileAddress_village: {
      requiredSelect: 'Kelurahan wajib diisi',
    },
    domicileAddress_postalCode: {
      requiredSelect: 'Kode pos wajib diisi',
    },
    religion: {
      requiredSelect: 'Agama wajib diisi',
    },
    citizenship: {
      requiredSelect: 'Kewarganegaraan wajib diisi',
    },
    housing_propertyType: {
      requiredSelect: 'Jenis tempat tinggal wajib diisi',
    },
    housing_residentialType: {
      requiredSelect: 'Status kepemilikan rumah wajib diisi',
    },
    housing_monthlyCost: {
      required: 'Biaya sewa/cicilan wajib diisi',
      numerical: 'Biaya sewa/cicilan hanya diperbolehkan angka',
      min: 'Biaya sewa/cicilan minimal Rp 100 ribu',
      max: 'Biaya sewa/cicilan maximal Rp 1 miliar',
    },
    housing_expenseCost: {
      required: 'Biaya PLN atau PDAM wajib diisi',
      numerical: 'Biaya PLN atau PDAM hanya diperbolehkan angka',
      min: 'Biaya PLN atau PDAM minimal Rp 100 ribu',
      max: 'Biaya PLN atau PDAM maximal Rp 1 miliar',
    },
    housing_numberOfPeople: {
      required: 'Jumlah penghuni wajib diisi',
      numerical: 'Jumlah penghuni hanya diperbolehkan angka',
      min: 'Jumlah penghuni minimal 1 orang',
      max: 'Jumlah penghuni maksimal 20 orang',
    },
    dependants: {
      required: 'Jumlah tanggungan wajib diisi',
      numerical: 'Jumlah tanggungan hanya diperbolehkan angka',
      max: 'Jumlah tanggungan maksimal 15',
    },
    mothersName: {
      required: 'Nama ibu kandung wajib diisi',
      maxlength: 'Nama ibu kandung maksimal 30 karakter',
    },
    contactAddress_street: {
      required: 'Alamat tempat tinggal wajib diisi',
      maxlength: 'Alamat tempat tinggal maksimal 100 karakter',
      minlength: 'Alamat tempat tinggal minimal 2 karakter',
      noSpace: 'Alamat tempat tinggal tidak boleh diawali spasi',
    },
    contactAddress_bldNumber: {
      required: 'Nomor blok wajib diisi',
      maxlength: 'Nomor blok maksimal 5 karakter',
      alphaNumeric: 'Nomor blok tidak diperbolehkan "-"',
    },
    contactAddress_flatNumber: {
      required: 'Nomor rumah wajib diisi',
      maxlength: 'Nomor rumah maksimal 5 karakter',
      alphaNumeric: 'Nomor rumah tidak diperbolehkan "-"',
    },
    contactAddress_rt: {
      required: 'RT wajib diisi',
      numerical: 'RT hanya diperbolehkan angka',
      maxlength: 'RT maksimal 3 karakter',
    },
    contactAddress_rw: {
      required: 'RW wajib diisi',
      numerical: 'RW hanya diperbolehkan angka',
      maxlength: 'RW maksimal 3 karakter',
    },
    contactAddress_province: {
      requiredSelect: 'Provinsi wajib diisi',
    },
    contactAddress_city: {
      requiredSelect: 'Kota wajib diisi',
    },
    contactAddress_district: {
      requiredSelect: 'Kecamatan wajib diisi',
    },
    contactAddress_village: {
      requiredSelect: 'Kelurahan wajib diisi',
    },
    contactAddress_postalCode: {
      requiredSelect: 'Kode pos wajib diisi',
    },
    income_jobType: {
      requiredSelect: 'Jenis pekerjaan wajib diisi',
    },
    income_employmentStatus: {
      requiredSelect: 'Status pekerjaan wajib diisi',
    },
    // income_taxId: {
    // 	required: 'Nomor NPWP wajib diisi',
    // 	maxlength: 'Nomor NPWP maksimal 20 karakter',
    // 	numerical: 'Nomor NPWP hanya diperbolehkan angka'
    // },
    // income_employeeId: {
    // 	required: 'Nomor kepegawaian wajib diisi',
    // 	maxlength: 'Nomor kepegawaian maksimal 20 karakter',
    // 	numerical: 'Nomor kepegawaian hanya diperbolehkan angka'
    // },
    income_employerName: {
      required: 'Nama perusahaan wajib diisi',
      maxlength: 'Nama perusahaan maksimal 80 karakter',
      noSpace: 'Nama perusahaan tidak boleh diawali spasi',
      noNumeric: 'Nama perusahaan tidak boleh angka',
    },
    income_workPosition: {
      requiredSelect: 'Jabatan di perusahaan wajib diisi',
    },
    income_monthlyIncome: {
      required: 'Penghasilan per bulan wajib diisi',
      numerical: 'Penghasilan per bulan hanya diperbolehkan angka',
      min: 'Penghasilan per bulan minimal Rp 1 juta',
      max: 'Penghasilan per bulan maximal Rp 1 miliar',
    },
    income_previousIncome: {
      required: 'Penghasilan sebelumnya wajib diisi',
      numerical: 'Penghasilan sebelumnya hanya diperbolehkan angka',
      max: 'Penghasilan sebelumnya maximal Rp 1 miliar',
    },
    income_businessName: {
      required: 'Nama perusahaan wajib diisi',
      minlength: 'Nama perusahaan minimal 2 karakter',
      maxlength: 'Nama perusahaan maksimal 80 karakter',
      noSpace: 'Nama perusahaan tidak boleh diawali spasi',
      noDash: 'Nama perusahaan tidak boleh diawali strip',
    },
    income_businessType: {
      requiredSelect: 'Jenis bisnis perusahaan wajib diisi & tidak boleh 0',
    },
    income_businessAge: {
      requiredSelect: 'Harap memilih salah satu',
    },
    income_businessIncome: {
      required: 'Keuntungan bisnis wajib diisi',
      numerical: 'Keuntungan bisnis hanya diperbolehkan angka',
      min: 'Keuntungan bisnis minimal Rp 1 juta',
      max: 'Keuntungan bisnis maximal Rp 1 miliar',
    },
    income_businessPromotion: {
      requiredSelect: 'Harap memilih salah satu',
    },
    income_businessPlace: {
      requiredSelect: 'Tempat bisnis wajib diisi',
    },
    income_numberOfEmployees: {
      requiredSelect: 'Jumlah karyawan wajib diisi',
    },
    maritalStatusType: {
      requiredSelect: 'Status pernikahan wajib diisi',
    },
    spouse_pin: {
      numerical: 'Nomor KTP pasangan hanya diperbolehkan angka',
      maxlength: 'Nomor KTP maksimal 16 karakter',
      minlength: 'Nomor KTP minimal 16 karakter',
      required: 'Nomor KTP pasangan wajib diisi',
    },
    spouse_name: {
      maxlength: 'Nama pasangan maksimal 50 karakter',
      required: 'Nama pasangan wajib diisi',
      noSpace: 'Nama pasangan tidak boleh diawali spasi',
      noNumeric: 'Nama pasangan tidak boleh angka',
    },
    spouse_dateOfBirth: {
      required: 'Tanggal lahir pasangan wajib diisi',
    },
    spouse_splitAssetAgreement: {
      required: 'Keterangan harta pasangan wajib dipilih',
    },
    personalReference_name: {
      required: 'Nama kerabat wajib diisi',
      maxlength: 'Nama kerabat maksimal 30 karakter',
      noSpace: 'Nama kerabat tidak boleh diawali spasi',
      noNumeric: 'Nama Kerabat tidak boleh angka',
    },
    personalReference_mobilePhone: {
      required: 'Nomor handphone referensi wajib diisi',
      numerical: 'Nomor handphone referensi hanya diperbolehkan angka',
      maxlength: 'Nomor handphone maksimal 13 karakter',
      minlength: 'Nomor handphone minimal 9 karakter',
      customMobilePhoneNumber: 'Format Nomor Handphone tidak sesuai',
    },
    // personalReference_homePhone: {
    // 	required: 'Nomor telepon rumah referensi wajib diisi',
    // 	numerical: 'Nomor telepon rumah hanya diperbolehkan angka',
    // 	maxlength: 'Nomor telepon rumah maksimal 14 karakter'
    // },
    personalReference_address: {
      required: 'Alamat referensi wajib diisi',
      maxlength: 'Alamat referensi maksimal 100 karakter',
      minlength: 'Alamat referensi minimal 2 karakter',
      noSpace: 'Alamat kerabat tidak boleh diawali spasi',
    },
    agreedForm: {
      required: 'Persetujuan wajib dipilih',
    },
  };
/**
 * @param {?} obj
 * @return {?}
 */
public setStore(obj: any) {
    const /** @type {?} */ tmp = Object.assign(this.store, obj);
    this.dispatcher.next(tmp);
  }
/**
 * * \@description to show separated number with dots on input type tel
 * * \@example 1000 to 1.000
 * * \@arg type are formControlName from the input type hidden, ex: 'housing_monthlyCost'
 * @param {?} type
 * @param {?} event
 * @return {?}
 */
public showDelimiter(type: string, event: KeyboardEvent): void {
    const /** @type {?} */ separatedNumber = numberDelimiter(event);

    this.store.form.patchValue({
      [`${type}_show`]: separatedNumber,
      [type]: removeDelimiter(separatedNumber),
    });
  }
/**
 * @param {?} token
 * @return {?}
 */
public getProfileData(token: string) {
    this.setStore({ actionBusy: true });

    return this.http.get(
      `${this.apiConstant.apiURL}/user/profile?tnk_token=${token}`,
    );
  }
/**
 * @return {?}
 */
public getBank(): void {
    this.setStore({ actionBusy: true });

    this.http.get(`${this.apiConstant.apiURL}/general/bank`).subscribe(
      (data: any) => {
        this.setStore({ banks: data.result, actionBusy: false });
      },
      (error: HttpErrorResponse) => {
        // tslint:disable-next-line
        console.log(error, 'BANK_API');
        this.setStore({ banks: [], actionBusy: false });
      },
    );
  }
/**
 * @param {?} event
 * @param {?} type
 * @return {?}
 */
public setBirthPlace(event, type: string) {
    const /** @type {?} */ value = event.target.value;

    switch (type) {
      case 'province': {
        const /** @type {?} */ provinces = this.store.provinces;
        let /** @type {?} */ provinceId;

        provinces.forEach(data => {
          if (data.province === value) {
            provinceId = data.province_id;
          }
        });

        this.store.form.patchValue({
          birthProvinceId: provinceId,
        });
        this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${value}&type=city`,
          )
          .subscribe((data: any) => {
            this.setStore({
              birthCities: data.result,
            });
          });

        break;
      }

      case 'city': {
        const /** @type {?} */ cities = this.store.birthCities;
        let /** @type {?} */ cityId;

        cities.forEach(data => {
          if (data.city === value) {
            cityId = data.city_id;
          }
        });

        this.store.form.patchValue({
          birthCityName: value,
          birthCityId: cityId,
        });

        break;
      }
    }
  }
/**
 * @param {?} cityId
 * @return {?}
 */
public getBirthCity(cityId) {
    this.setStore({ actionBusy: true });

    this.http
      .get(
        `${this.apiConstant.apiURL}/general/region?city=${cityId}&type=cityid`,
      )
      .subscribe(
        (data: any) => {
          this.store.form.patchValue({
            birthProvinceId: data.result[0].province_id,
          });

          this.http
            .get(
              `${this.apiConstant.apiURL}/general/region?province=${data.result[0].province_id}&type=city`,
            )
            .subscribe((data: any) => {
              this.setStore({
                birthCities: data.result,
                actionBusy: false,
              });
            });
        },
        (error: HttpErrorResponse) => {
          // tslint:disable-next-line
          console.log(error, 'BIRTH_CITY_API');
          this.setStore({ birthCities: [], actionBusy: false });
        },
      );
  }
/**
 * @param {?} value
 * @param {?} arr
 * @param {?} prefix
 * @param {?} type
 * @return {?}
 */
public transformRegionValue(value: string, arr: any[], prefix, type) {
    const /** @type {?} */ regionArr = arr.filter(
      item =>
        item[`${prefix}${type === 'id' ? '' : '_id'}`].toString() === value,
    );
    if (regionArr.length) {
      return regionArr[0][type ? `${prefix}_id` : prefix];
    } else {
      return '0';
    }
  }
/**
 * @param {?} contactAdressData
 * @return {?}
 */
private assignContactAddressObject(
    contactAdressData: DataRegions,
  ): DataRegions {
    const /** @type {?} */ contactAddress = contactAdressData || ( /** @type {?} */(({} as DataRegions)));
    if (this.isObjectEmpty(contactAddress)) {
      contactAddress.province = '0';
      contactAddress.city = '0';
      contactAddress.district = '0';
      contactAddress.village = '0';
    }

    const /** @type {?} */ contactAddressObj = {
      province: this.validateNullData(contactAddress.province).toUpperCase(),
      city: this.validateNullData(contactAddress.city).toUpperCase(),
      district: this.validateNullData(contactAddress.district).toUpperCase(),
      village: this.validateNullData(contactAddress.village).toUpperCase(),
    };
    return contactAddressObj;
  }
/**
 * @param {?} domicileAddressData
 * @return {?}
 */
private assignDomicileAddressObject(
    domicileAddressData: DataRegions,
  ): DataRegions {
    const /** @type {?} */ domicileAddress = domicileAddressData || ( /** @type {?} */(({} as DataRegions)));
    if (this.isObjectEmpty(domicileAddress)) {
      domicileAddress.province = '0';
      domicileAddress.city = '0';
      domicileAddress.district = '0';
      domicileAddress.village = '0';
    }

    const /** @type {?} */ domicileAddressObj = {
      ...domicileAddress,
      province: this.validateNullData(domicileAddress.province).toUpperCase(),
      city: this.validateNullData(domicileAddress.city).toUpperCase(),
      district: this.validateNullData(domicileAddress.district).toUpperCase(),
      village: this.validateNullData(domicileAddress.village).toUpperCase(),
    };

    return domicileAddressObj;
  }
/**
 * @param {?} obj
 * @return {?}
 */
private isObjectEmpty(obj: object): boolean {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
/**
 * @param {?} formData
 * @param {?} addressType
 * @param {?=} isCookie
 * @return {?}
 */
public getInitRegions(formData, addressType: string, isCookie?) {
    let /** @type {?} */ formDataRegions: DataRegions;
    if (isCookie) {
      formDataRegions = Object.assign(
        {},
        {
          province: this.validateNullData(
            !addressType
              ? formData.domicileAddress_province
              : formData.contactAddress_province,
          ).toUpperCase(),

          city: this.validateNullData(
            !addressType
              ? formData.domicileAddress_city
              : formData.contactAddress_city,
          ).toUpperCase(),
          district: this.validateNullData(
            !addressType
              ? formData.domicileAddress_district
              : formData.contactAddress_district,
          ).toUpperCase(),
          village: this.validateNullData(
            !addressType
              ? formData.domicileAddress_village
              : formData.contactAddress_village,
          ).toUpperCase(),
        },
      );
    } else {
      if (addressType === 'Contact') {
        formDataRegions = this.assignContactAddressObject(
          formData.contactAddress,
        );
      } else {
        formDataRegions = this.assignDomicileAddressObject(
          formData.domicileAddressObj,
        );
      }
    }

    const /** @type {?} */ provinceId = isCookie
      ? formDataRegions.province
      : this.transformRegionValue(
          formDataRegions.province,
          this.store.provinces,
          'province',
          'id',
        );

    this.setStore({
      [!addressType
        ? 'domicileAddress_provinceId'
        : 'contactAddress_provinceId']: provinceId,
    });

    this.getRegions(
      { province: provinceId },
      'city',
      'map',
      addressType,
    ).subscribe(
      () => {
        const /** @type {?} */ cityId = isCookie
          ? formDataRegions.city
          : this.transformRegionValue(
              formDataRegions.city,
              this.store[`cities${addressType ? addressType : ''}`],
              'city',
              'id',
            );

        this.setStore({
          [!addressType
            ? 'domicileAddress_cityId'
            : 'contactAddress_cityId']: cityId,
        });

        this.getRegions(
          { province: provinceId, city: cityId },
          'district',
          'map',
          addressType,
        ).subscribe(
          () => {
            const /** @type {?} */ districtId = isCookie
              ? formDataRegions.district
              : this.transformRegionValue(
                  formDataRegions.district,
                  this.store[`districts${addressType ? addressType : ''}`],
                  'district',
                  'id',
                );

            this.setStore({
              [!addressType
                ? 'domicileAddress_districtId'
                : 'contactAddress_districtId']: districtId,
            });

            this.getRegions(
              {
                province: provinceId,
                city: cityId,
                district: districtId,
              },
              'village',
              'map',
              addressType,
            ).subscribe(
              () => {
                const /** @type {?} */ villageId = isCookie
                  ? formDataRegions.village
                  : this.transformRegionValue(
                      formDataRegions.village,
                      this.store[`villages${addressType ? addressType : ''}`],
                      'village',
                      'id',
                    );

                const /** @type {?} */ selectedVillages = !addressType
                  ? this.store.villages
                  : this.store.villagesContact;
                const /** @type {?} */ selected = selectedVillages.find(
                  village => village.village_id === villageId,
                );

                this.setStore({
                  [!addressType
                    ? 'domicileAddress_villageId'
                    : 'contactAddress_villageId']: villageId,
                  [!addressType
                    ? 'domicileAddress_postalCode'
                    : 'contactAddress_postalCode']: selected
                    ? selected.postal_code
                    : '0',
                });

                // For 'domicilieAddress'
                if (!addressType) {
                  this.dispatcherInitRegions.next(
                    Object.assign(this.initRegions, {
                      isRegionsDomicileFetched: true,
                    }),
                  );
                }
                // For 'contactAddress'
                else {
                  this.dispatcherInitRegions.next(
                    Object.assign(this.initRegions, {
                      isRegionsContactFetched: true,
                    }),
                  );
                }
              },
              (err: HttpErrorResponse) => {
                this.dispatcherInitRegions.next(
                  Object.assign(this.initRegions, {
                    isError: true,
                  }),
                );
              },
            );
          },
          (err: HttpErrorResponse) => {
            this.dispatcherInitRegions.next(
              Object.assign(this.initRegions, { isError: true }),
            );
          },
        );
      },
      (err: HttpErrorResponse) => {
        this.dispatcherInitRegions.next(
          Object.assign(this.initRegions, { isError: true }),
        );
      },
    );
  }
/**
 * @param {?} inputValue
 * @return {?}
 */
private validateNullData(inputValue: string): string {
    return inputValue || '';
  }
/**
 * @param {?} data
 * @param {?} type
 * @param {?=} methodType
 * @param {?=} objType
 * @param {?=} onChange
 * @return {?}
 */
public getRegions(
    data,
    type,
    methodType?: any,
    objType?: string,
    onChange?: boolean,
  ): Observable<any> {
    this.setStore({ actionBusy: true });

    switch (type) {
      case 'province': {
        this.http
          .get(`${this.apiConstant.apiURL}/general/region?type=province`)
          .subscribe(
            (data: any) => {
              this.setStore({
                provinces: data.result,
                actionBusy: false,
              });
            },
            (error: HttpErrorResponse) => {
              // tslint:disable-next-line
              console.log(error, 'REGIONS_API');
              this.dispatcherInitRegions.next(
                Object.assign(this.initRegions, {
                  isError: true,
                }),
              );
              this.setStore({ actionBusy: false });
            },
          );

        break;
      }

      case 'city': {
        if (!objType && onChange) {
          if (data.province <= 0) {
            this.setStore({
              cities: [],
              districts: [],
              villages: [],
            });

            this.store.form.patchValue({
              domicileAddress_city: '0',
              domicileAddress_district: '0',
              domicileAddress_village: '0',
              domicileAddress_postalCode: '0',
            });
            return;
          }

          this.setStore({
            cities: [],
            districts: [],
            villages: [],
          });

          this.store.form.patchValue({
            domicileAddress_city: '0',
            domicileAddress_district: '0',
            domicileAddress_village: '0',
            domicileAddress_postalCode: '0',
          });
        } else if (objType && onChange) {
          if (data.province <= 0) {
            this.setStore({
              citiesContact: [],
              districtsContact: [],
              villagesContact: [],
            });

            this.store.form.patchValue({
              contactAddress_city: '0',
              contactAddress_district: '0',
              contactAddress_village: '0',
              contactAddress_postalCode: '0',
            });
            return;
          }

          this.setStore({
            citiesContact: [],
            districtsContact: [],
            villagesContact: [],
          });

          this.store.form.patchValue({
            contactAddress_city: '0',
            contactAddress_district: '0',
            contactAddress_village: '0',
            contactAddress_postalCode: '0',
          });
        }

        return this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${data.province}\
					&type=city`,
          )
          [methodType ? methodType : 'subscribe'](
            (res: any) => {
              if (!objType) {
                this.setStore({
                  cities: res.result,
                  domicileAddress_provinceId: data.province,
                  actionBusy: false,
                });
              } else {
                this.setStore({
                  citiesContact: res.result,
                  contactAddress_provinceId: data.province,
                  actionBusy: false,
                });
              }
            },
            (error: HttpErrorResponse) => {
              // tslint:disable-next-line
              console.log(error, 'REGIONS_API');
              this.setStore({ actionBusy: false });
            },
          );
      }

      case 'district': {
        if (!objType && onChange) {
          if (data.city <= 0) {
            this.setStore({
              villages: [],
              districts: [],
            });

            this.store.form.patchValue({
              domicileAddress_district: '0',
              domicileAddress_village: '0',
              domicileAddress_postalCode: '0',
            });
            return;
          }

          this.setStore({
            villages: [],
            districts: [],
          });

          this.store.form.patchValue({
            domicileAddress_district: '0',
            domicileAddress_village: '0',
            domicileAddress_postalCode: '0',
          });
        } else if (objType && onChange) {
          if (data.city <= 0) {
            this.setStore({
              villagesContact: [],
              districtsContact: [],
            });

            this.store.form.patchValue({
              contactAddress_district: '0',
              contactAddress_village: '0',
              contactAddress_postalCode: '0',
            });
            return;
          }

          this.setStore({
            villagesContact: [],
            districtsContact: [],
          });

          this.store.form.patchValue({
            contactAddress_district: '0',
            contactAddress_village: '0',
            contactAddress_postalCode: '0',
          });
        }

        return this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${data.province}\
					&city=${data.city}&type=district`,
          )
          [methodType ? methodType : 'subscribe'](
            (res: any) => {
              if (!objType) {
                this.setStore({
                  districts: res.result,
                  domicileAddress_cityId: data.city,
                  actionBusy: false,
                });
              } else {
                this.setStore({
                  districtsContact: res.result,
                  contactAddress_cityId: data.city,
                  actionBusy: false,
                });
              }
            },
            (error: HttpErrorResponse) => {
              // tslint:disable-next-line
              console.log(error, 'REGIONS_API');
              this.setStore({ actionBusy: false });
            },
          );
      }

      case 'village': {
        if (!objType && onChange) {
          if (data.district <= 0) {
            this.setStore({
              villages: [],
            });

            this.store.form.patchValue({
              domicileAddress_postalCode: '0',
              domicileAddress_village: '0',
            });
            return;
          }

          this.setStore({
            villages: [],
          });

          this.store.form.patchValue({
            domicileAddress_postalCode: '0',
            domicileAddress_village: '0',
          });
        } else if (objType && onChange) {
          if (data.district <= 0) {
            this.setStore({
              villagesContact: [],
            });

            this.store.form.patchValue({
              contactAddress_village: '0',
              contactAddress_postalCode: '0',
            });
            return;
          }

          this.setStore({
            villagesContact: [],
          });

          this.store.form.patchValue({
            contactAddress_village: '0',
            contactAddress_postalCode: '0',
          });
        }

        return this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${data.province}\
					&city=${data.city}&district=${data.district}&type=village`,
          )
          [methodType ? methodType : 'subscribe'](
            (res: any) => {
              if (!objType) {
                this.setStore({
                  villages: res.result,
                  domicileAddress_districtId: data.district,
                  actionBusy: false,
                });
              } else {
                this.setStore({
                  villagesContact: res.result,
                  contactAddress_districtId: data.district,
                  actionBusy: false,
                });
              }
            },
            (error: HttpErrorResponse) => {
              // tslint:disable-next-line
              console.log(error, 'REGIONS_API');
              this.setStore({ actionBusy: false });
            },
          );

        // break;
      }

      case 'postal_code': {
        if (data.village <= 0) {
          return;
        }

        const /** @type {?} */ selectedVillages = !objType
          ? this.store.villages
          : this.store.villagesContact;
        const /** @type {?} */ formVillageId = !objType
          ? this.store.form.value.domicileAddress_village
          : this.store.form.value.contactAddress_village;
        const /** @type {?} */ selected = selectedVillages.find(
          village => village.village_id === formVillageId,
        );

        this.setStore({
          [!objType
            ? 'domicileAddress_villageId'
            : 'contactAddress_villageId']: formVillageId,
          [!objType
            ? 'domicileAddress_postalCode'
            : 'contactAddress_postalCode']: selected.postal_code,
        });

        this.store.form.patchValue({
          [!objType
            ? 'domicileAddress_postalCode'
            : 'contactAddress_postalCode']: selected.postal_code,
        });
        break;
      }

      default:
        return;
    }
  }
/**
 * @param {?} loanAmount
 * @param {?} loanPeriod
 * @return {?}
 */
public calcInitMonthly(loanAmount: number, loanPeriod: number) {
    const /** @type {?} */ monthlyFee = 0;
    const /** @type {?} */ adminFeeAnnual = 540000;
    const /** @type {?} */ interestAnnual = 0.59;
    let /** @type {?} */ monthlyPaymentRaw = 0;
    const /** @type {?} */ ret = [];

    const /** @type {?} */ monthlyInterest = interestAnnual / 12;
    const /** @type {?} */ monthlyAdminFee = adminFeeAnnual / loanPeriod;

    monthlyPaymentRaw =
      loanAmount /
      ((1 - 1 / Math.pow(1.0 + monthlyInterest, loanPeriod)) / monthlyInterest);
    monthlyPaymentRaw += monthlyAdminFee + monthlyFee;

    return monthlyPaymentRaw;
  }
/**
 * @param {?} bool
 * @return {?}
 */
public setDomicileAsContact(bool): void {
    if (bool) {
      this.store.form.patchValue({
        contactAddress_street: this.store.form.value.domicileAddress_street,
        contactAddress_bldNumber: this.store.form.value
          .domicileAddress_bldNumber,
        contactAddress_flatNumber: this.store.form.value
          .domicileAddress_flatNumber,
        contactAddress_rt: this.store.form.value.domicileAddress_rt,
        contactAddress_rw: this.store.form.value.domicileAddress_rw,
        contactAddress_province: this.store.form.value.domicileAddress_province,
        contactAddress_city: this.store.form.value.domicileAddress_city,
        contactAddress_district: this.store.form.value.domicileAddress_district,
        contactAddress_village: this.store.form.value.domicileAddress_village,
        contactAddress_postalCode: this.store.form.value
          .domicileAddress_postalCode,
      });

      this.setStore({ showStep5Form: false });
      this.cookieService.set('TNK-FORM5', true);
    } else {
      this.store.form.patchValue({
        contactAddress_street: '',
        contactAddress_bldNumber: '',
        contactAddress_flatNumber: '',
        contactAddress_rt: '',
        contactAddress_rw: '',
        contactAddress_province: '0',
        contactAddress_city: '0',
        contactAddress_district: '0',
        contactAddress_village: '0',
        contactAddress_postalCode: '0',
      });

      if (this.store.provinces.length === 0) {
        this.getRegions({}, 'province');
      }

      this.setStore({ showStep5Form: true });
      this.cookieService.set('TNK-FORM5', false);
    }
  }
/**
 * @param {?=} ktp
 * @return {?}
 */
public checkUserKTP(ktp?: string) {
    const /** @type {?} */ currentKtp = this.store.form.value.pin
      ? this.store.form.value.pin
      : ktp;

    this.setStore({ loadingKTP: false, disabledNextButton: true });

    this.http
      .get(`${this.apiConstant.apiURL}/user/is-exist?ktp=${currentKtp}`)
      .subscribe(
        (data: any) => {
          if (data.result.exists === 'Y') {
            this.setStore({ doubleKTP: true });

            setTimeout(() => {
              this.setStore({
                disabledNextButton: this.stepValidator(1),
                loadingKTP: true,
              });
            }, 50);
          } else {
            this.setStore({ doubleKTP: false });

            setTimeout(() => {
              this.setStore({
                disabledNextButton: this.stepValidator(1),
                loadingKTP: true,
              });
            }, 50);
          }
        },
        (error: HttpErrorResponse) => {
          // tslint:disable-next-line
          console.log('CHECK_KTP', error);
          this.setStore({ doubleKTP: false });

          setTimeout(() => {
            this.setStore({
              disabledNextButton: this.stepValidator(1),
              loadingKTP: true,
            });
          }, 50);
        },
      );
  }
/**
 * @param {?} obj
 * @return {?}
 */
public deleteUnwantedObject(obj: any): void {
    delete obj.housing.monthlyResidenceCostShow;
    delete obj.housing.electricityAndWaterCostShow;
    delete obj.income.businessIncomeShow;
    delete obj.income.rentalCostsShow;
    delete obj.income.monthlyIncomeShow;
    delete obj.income.previousIncomeShow;
  }
/**
 * @param {?} step
 * @param {?} type
 * @return {?}
 */
public stepHandler(step: number, type: string): void {
    if (type === 'next') {
      if (step < 5) {
        const /** @type {?} */ nextStep: number = step + 1;

        // if(nextStep == 2) {
        // 	const gender = this.formData.oldVal_gender? this.formData.oldVal_gender :
        // 		parseInt(this.store.form.value.pin.substr(6,1)) < 4? 'L' : 'P';

        // 	const ktpGender = parseInt(this.store.form.value.pin.substr(6,1)) < 4? 'L' : 'P';

        // 	let birthDate, birthMonth, birthYear;

        // 	if(gender == 'P' || gender == 'Female') {
        // 		birthDate = parseInt(this.store.form.value.pin.substr(6,2)) - 40;
        // 	}
        // 	else {
        // 		birthDate = this.store.form.value.pin.substr(6,2);
        // 	}

        // 	birthMonth = parseInt(this.store.form.value.pin.substr(8,2)) - 1;
        // 	birthYear = this.store.form.value.pin.substr(10,2);

        // 	let birthday:any = new Date(birthYear, birthMonth, birthDate);
        // 	const ktpDob = moment(birthday).format('YYYY-MM-DD');

        // 	birthday = this.formData.oldVal_dob? this.formData.oldVal_dob :
        // 	 moment(birthday).format('YYYY-MM-DD');

        // 	this.setStore({ oldVal_gender: (gender == 'L' || gender == 'Male')? 'Male' : 'Female', oldVal_dob: birthday });
        // 	this.store.form.patchValue({ gender: (gender == 'L' || gender == 'Male')? 'Male' : 'Female', dateOfBirth: birthday });

        // 	this.store.form.controls['dateOfBirth'].valueChanges.subscribe(data => {
        // 		if(data != ktpDob) {
        // 			this.setStore({ PINDataConfirmationBlock: true });
        // 		}
        // 		else {
        // 			this.setStore({ PINDataConfirmationBlock: false });
        // 		}
        // 	});

        // 	this.store.form.controls['gender'].valueChanges.subscribe(data => {
        // 		let tmpData = ktpGender == 'L'? 'Male' : 'Female';

        // 		if(data != tmpData) {
        // 			this.setStore({ PINDataConfirmationBlock: true });
        // 		}
        // 		else {
        // 			this.setStore({ PINDataConfirmationBlock: false });
        // 		}
        // 	});
        // }

        // if(nextStep == 3) {
        // 	const lnData = Object.assign({}, Cookies.getJSON(TNK_LOAN_DATA));
        // 	lnData.oldVal_gender = this.store.form.controls.gender.value;
        // 	lnData.oldVal_dob = this.store.form.controls.dateOfBirth.value;

        // 	Cookies.set(TNK_LOAN_DATA, lnData);
        // }

        // if(nextStep == 9) {
        // 	this.findBankByCode(this.store.form.controls.bankName.value);
        // }

        if (this.store.stepURI.length === 0) {
          this.setStore({
            step: nextStep,
            disabledNextButton: this.stepValidator(nextStep),
          });
          this.cookieService.set('TNKActiveStep', nextStep);
        } else {
          this.cookieService.set('TNKActiveStep', nextStep);
          this.setStore({
            disabledNextButton: this.stepValidator(nextStep),
          });
          setTimeout(() => {
            // location.href = this.store.stepURI[step];
            this.router.navigateByUrl(this.store.stepURI[step]);
            this.setStore({ step: nextStep });

            const /** @type {?} */ loanData = this.cookieService.get('TNK-SL-LNDATA');

            this.buildForm(loanData);
          }, 50);
        }
      } else {
        // submit loan
        if (this.store.form.invalid) {
          alert('Mohon lengkapi data formulir yang belum diisi');
        } else {
          this.setStore({ submitBusy: true });

          this.submitRepeatLoan();
        }
      }
    } else {
      if (step > 1) {
        const /** @type {?} */ prevStep: number = step - 1;
        this.setStore({
          step: prevStep,
          disabledNextButton: this.stepValidator(prevStep),
        });
        this.cookieService.set('TNKActiveStep', prevStep);

        if (this.store.stepURI.length === 0) {
          this.setStore({
            step: prevStep,
            disabledNextButton: this.stepValidator(prevStep),
          });
          this.cookieService.set('TNKActiveStep', prevStep);
        } else {
          this.setStore({
            disabledNextButton: this.stepValidator(prevStep),
          });
          this.cookieService.set('TNKActiveStep', prevStep);

          setTimeout(() => {
            // location.href = this.store.stepURI[prevStep-1];
            this.router.navigateByUrl(this.store.stepURI[prevStep - 1]);
            this.setStore({ step: prevStep });

            const /** @type {?} */ loanData = this.cookieService.get('TNK-SL-LNDATA');
            this.buildForm(loanData);
          }, 50);
        }
      } else {
        if (step === 1) {
          this.router.navigateByUrl('/customer/dashboard/second-loan');
        }
      }
    }
  }
/**
 * @return {?}
 */
private submitRepeatLoan(): void {
    const /** @type {?} */ additionalParameter = this.store.additionalParameter;
    const /** @type {?} */ isCookie = false;

    const /** @type {?} */ transformedLoanData = this.transformReactiveToJSON(
      this.store.form.value,
      additionalParameter,
      isCookie,
    );

    this.deleteUnwantedObject(transformedLoanData);

    const /** @type {?} */ dobNotNumber = isNaN(transformedLoanData.dateOfBirth);

    if (dobNotNumber) {
      const { ktpBirthday } = this.transformKtpData(transformedLoanData.pin);
      transformedLoanData.dateOfBirth = ktpBirthday;
    }

    const /** @type {?} */ apiURLToPostLoan =
      transformedLoanData.income.jobType === JOB_TYPE.entrepreneur
        ? `${this.apiConstant.apiURL}/entrepreneur/loan`
        : `${this.apiConstant.apiURL}/loan/new?tnk_token=${this.store.accessToken}`;

    const /** @type {?} */ token = this.cookieService.get(TNK_TOKEN);

    const /** @type {?} */ headersToPostLoan = new HttpHeaders({
      environment: POST_LOAN_ENVIRONMENT,
      version: POST_LOAN_VERSION,
      loantype:
        transformedLoanData.income.jobType === JOB_TYPE.entrepreneur
          ? ENTREPRENEUR_LOAN_TYPE
          : '',
      'x-auth-token':
        transformedLoanData.income.jobType === JOB_TYPE.entrepreneur
          ? this.authService.getAuthToken(token)
          : '',
    });

    this.http
      .post(
        //  if entrepreneur post to /entrepreneur/loan with x-auth
        apiURLToPostLoan,
        transformedLoanData,
        { headers: headersToPostLoan },
      )
      .subscribe(
        (data: any) => {
          if (data.result.code === '00911') {
            setTimeout(() => {
              location.href = MAINTENANCE_ROUTE;
            }, 300);
            return;
          }
          this.handleAffiliateTracking(this.store.form.value.pin, data);

          this.removeCookies();

          setTimeout(() => {
            location.href = `${this.store.successCallbackURI}?id=${data.result.id}`;
          }, 500);
        },
        (error: HttpErrorResponse) => {
          if (this.store.debug) {
            // tslint:disable-next-line
            console.log('ERROR_POST', error);
          } else {
            this.handleNewLoanError(error);
          }
        },
      );
  }
/**
 * @param {?} error
 * @return {?}
 */
private handleNewLoanError(error: HttpErrorResponse): void {
    /* handle New Loan Fraud error */
    const /** @type {?} */ fraudErrorCode = error.error.result.code === 6001;

    if (error.status === 400 && fraudErrorCode) {
      this.setStore({
        isFraudAttemptAlert: true,
      });
    }

    /* handle New Loan error */
    if (error.status >= 500) {
      location.href = this.store.errorServerCallbackURI;
    }

    if (error.status >= 400 && error.status < 500 && !fraudErrorCode) {
      if (error.status === 401) {
        this.logout();
      }

      location.href = this.store.busyServerCallbackURI;
    }
  }
/**
 * @return {?}
 */
private logout(): void {
    this.cookieService.remove('tnk_token');
    this.router.navigateByUrl('/customer/login');
  }
/**
 * @return {?}
 */
private removeCookies(): void {
    this.cookieService.remove('TNK-SL-SLRDATA');
    this.cookieService.remove('TNK-SL-LNDATA');
    this.cookieService.remove('TNK-REF');
    this.cookieService.remove('TNKActiveStep');
    this.cookieService.remove('TNK-LN-SUCCESS');
    this.cookieService.remove('tnk_topup');
    this.cookieService.remove('__do_visitorId');
    this.cookieService.remove('__fin_visitorId');
    this.cookieService.remove('__lProf_id');
    this.cookieService.remove('__lProf_paramId');
  }
/**
 * Create cookie contained with affiliate tracking links
 * @param {?} ktp
 * @param {?} data
 * @return {?}
 */
private handleAffiliateTracking(ktp: string, data: any) {
    const /** @type {?} */ refcode = this.cookieService.get('TNK-REF');
    const /** @type {?} */ lProfId = this.cookieService.get('__lProf_id');
    const /** @type {?} */ lProfParamId = this.cookieService.get('__lProf_paramId');
    const /** @type {?} */ clickId = this.cookieService.get('__clickId');

    if (refcode) {
      if (refcode.includes(this.cashtreeRefcodeFormat)) {
        this.setCashTreeCallback(data, clickId);
        return;
      }

      if (lProfId && lProfParamId) {
        const /** @type {?} */ linkProfPath = `${this.apiConstant.trackerURLLinkProfAf}?OrderID=${ktp}&ClickHash=${lProfParamId}&CampaignID=d64g9n85&AffiliateID=${lProfId}`;
        this.cookieService.set(this.affiliateCookieName, linkProfPath);
        return;
      }
    }
  }
/**
 * @param {?} data
 * @param {?} clickId
 * @return {?}
 */
private setCashTreeCallback(data: any, clickId: any) {
    const /** @type {?} */ loanData = JSON.parse(this.cookieService.get('TNK-SL-LNDATA'));
    const /** @type {?} */ refid = data.result.id;
    const /** @type {?} */ cashtreeCallback = `${this.apiConstant.trackerURLLinkCashTree}&clickid=${clickId}&sub1=${loanData.pin}&sub2=${refid}`;
    return this.cookieService.set(this.affiliateCookieName, cashtreeCallback);
  }
/**
 * @param {?} bool
 * @return {?}
 */
public confirmPINDataChanges(bool) {
    if (this.store.step === 2) {
      if (bool) {
        this.setStore({
          oldVal_gender: this.store.form.value.gender,
          oldVal_dob: this.store.form.value.dateOfBirth,
          PINDataConfirmationBlock: false,
        });
      } else {
        this.store.form.patchValue({
          gender: this.store.oldVal_gender,
          dateOfBirth: this.store.oldVal_dob,
        });
      }
    }
  }
/**
 * @param {?} status
 * @return {?}
 */
public setServiceArea(status: string) {
    if (status === 'yes') {
      this.setStore({
        serviceAreaIncluded: status,
        disabledNextButton: false,
      });
    } else {
      this.setStore({
        serviceAreaIncluded: status,
        disabledNextButton: true,
      });
    }
  }
/**
 * @param {?} step
 * @param {?=} type
 * @return {?}
 */
public stepValidator(step: number, type?: string) {
    switch (step) {
      case 1: {
        if (
          this.store.form.controls['mobilePhoneNumber'].valid &&
          this.store.form.controls['emailAddress'].valid &&
          this.store.form.controls['bankName'].valid &&
          this.store.form.controls['bankAccount'].valid &&
          this.store.form.controls['mothersName'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 2: {
        if (
          this.store.form.controls['ktpName'].valid &&
          this.store.form.controls['birthCityId'].valid &&
          this.store.form.controls['birthProvinceId'].valid &&
          this.store.form.controls['dateOfBirth'].valid &&
          this.store.form.controls['gender'].valid &&
          this.store.form.controls['domicileAddress_street'].valid &&
          this.store.form.controls['domicileAddress_bldNumber'].valid &&
          this.store.form.controls['domicileAddress_buildingType'].valid &&
          this.store.form.controls['domicileAddress_flatNumber'].valid &&
          this.store.form.controls['domicileAddress_rt'].valid &&
          this.store.form.controls['domicileAddress_rw'].valid &&
          this.store.form.controls['domicileAddress_province'].valid &&
          this.store.form.controls['domicileAddress_city'].valid &&
          this.store.form.controls['domicileAddress_district'].valid &&
          this.store.form.controls['domicileAddress_village'].valid &&
          this.store.form.controls['domicileAddress_postalCode'].valid &&
          this.store.form.controls['religion'].valid &&
          this.store.form.controls['citizenship'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 3: {
        if (
          this.store.form.controls['housing_propertyType'].valid &&
          this.store.form.controls['housing_residentialType'].valid &&
          this.store.form.controls['housing_monthlyCost'].valid &&
          this.store.form.controls['housing_expenseCost'].valid &&
          this.store.form.controls['housing_numberOfPeople'].valid &&
          this.store.form.controls['mothersName'].valid &&
          this.store.form.controls['contactAddress_street'].valid &&
          this.store.form.controls['contactAddress_bldNumber'].valid &&
          this.store.form.controls['contactAddress_flatNumber'].valid &&
          this.store.form.controls['contactAddress_rt'].valid &&
          this.store.form.controls['contactAddress_rw'].valid &&
          this.store.form.controls['contactAddress_province'].valid &&
          this.store.form.controls['contactAddress_city'].valid &&
          this.store.form.controls['contactAddress_district'].valid &&
          this.store.form.controls['contactAddress_village'].valid &&
          this.store.form.controls['contactAddress_postalCode'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 4: {
        if (
          this.store.form.value['income_jobType'] !== 'Unemployed' &&
          this.store.form.value['income_jobType'] !== 'Student' &&
          this.store.form.value['income_jobType'] !== 'Other' &&
          this.store.form.value['income_jobType'] !== 'RetiredPublicServant' &&
          this.store.form.value['income_jobType'] !== 'Retired' &&
          this.store.form.controls['income_jobType'].valid &&
          this.store.form.controls['income_employmentStatus'].valid &&
          this.store.form.controls['income_employerName'].valid &&
          this.store.form.controls['income_workPosition'].valid &&
          this.store.form.controls['income_monthlyIncome'].valid &&
          this.store.form.controls['income_previousIncome'].valid &&
          this.store.form.controls.income_businessName.valid &&
          this.store.form.controls.income_businessType.valid &&
          this.store.form.controls.income_businessAge.valid &&
          this.store.form.controls.income_businessIncome.valid &&
          this.store.form.controls.income_businessPromotion.valid &&
          this.store.form.controls.income_businessPlace.valid &&
          this.store.form.controls.income_numberOfEmployees.valid
        ) {
          return false;
        } else if (
          this.store.form.value['income_jobType'] === 'Unemployed' ||
          this.store.form.value['income_jobType'] === 'Student' ||
          this.store.form.value['income_jobType'] === 'Other' ||
          this.store.form.value['income_jobType'] === 'RetiredPublicServant' ||
          this.store.form.value['income_jobType'] === 'Retired'
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 5: {
        if (
          this.store.form.value['maritalStatusType'] === 'Married' &&
          this.store.form.controls['maritalStatusType'].valid &&
          this.store.form.controls['spouse_pin'].valid &&
          this.store.form.controls['spouse_name'].valid &&
          this.store.form.controls['spouse_dateOfBirth'].valid &&
          this.store.form.controls['spouse_splitAssetAgreement'].value !== '' &&
          this.store.form.controls['personalReference_name'].valid &&
          this.store.form.controls['personalReference_mobilePhone'].valid &&
          this.store.form.controls['personalReference_address'].valid &&
          this.store.form.controls['dependants'].valid &&
          this.store.form.controls['educationType'].valid
        ) {
          return false;
        } else if (
          (this.store.form.controls['maritalStatusType'].value === 'Divorced' ||
            this.store.form.controls['maritalStatusType'].value === 'Single') &&
          this.store.form.controls['personalReference_name'].valid &&
          this.store.form.controls['personalReference_mobilePhone'].valid &&
          this.store.form.controls['personalReference_address'].valid &&
          this.store.form.controls['dependants'].valid &&
          this.store.form.controls['educationType'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      // case 7: {
      // 	if(this.store.form.controls['pin'].valid && this.store.form.controls['bankName'].valid
      // 		&& this.store.form.controls['bankAccount'].valid && this.store.form.controls['emailAddress'].valid
      // 		&& this.store.form.controls['mobilePhoneNumber'].valid && this.store.form.controls['loanAmount'].value &&
      // 		this.store.form.controls['loanPeriod'].value && this.store.form.controls['loanPurpose'].value &&
      // 		this.store.form.controls['agreedForm'].value == true) {

      // 		return false;
      // 	}
      // 	else {
      // 		return true;
      // 	}
      // }
    }
  }
/**
 * @param {?=} group
 * @param {?=} isCookie
 * @return {?}
 */
public buildForm(group?: any, isCookie?: boolean): void {
    let /** @type {?} */ form5;
    let /** @type {?} */ form;

    const /** @type {?} */ formData = this.cookieService.get('TNK-SL-LNDATA')
      ? this.cookieService.get('TNK-SL-LNDATA')
      : {};
    const /** @type {?} */ sliderData = this.cookieService.get('TNK-SL-SLRDATA')
      ? this.cookieService.get('TNK-SL-SLRDATA')
      : {};

    const /** @type {?} */ additionalData = this.store.additionalParameter;
    let /** @type {?} */ transformedRegionsData: any = {};

    if (!isCookie) {
      let /** @type {?} */ formUserData = group;
      if (
        !group.housing &&
        !group.contactAddress &&
        !group.income &&
        !group.spouse &&
        !group.personalReference
      ) {
        formUserData = this.transformReactiveToJSON(
          group,
          additionalData,
          isCookie,
        );
      }
      const /** @type {?} */ tmp = this.transformObject.formModel(
        sliderData,
        formUserData,
        'second-loan',
      );
      form = this.fb.group(tmp);
      transformedRegionsData = Object.assign(
        {},
        {
          domicileAddress_city: this.store.domicileAddress_cityId.toString(),
          domicileAddress_province: this.store.domicileAddress_provinceId.toString(),
          domicileAddress_district: this.store.domicileAddress_districtId.toString(),
          domicileAddress_village: this.store.domicileAddress_villageId.toString(),
          contactAddress_city: this.store.contactAddress_cityId.toString(),
          contactAddress_province: this.store.contactAddress_provinceId.toString(),
          contactAddress_district: this.store.contactAddress_districtId.toString(),
          contactAddress_village: this.store.contactAddress_villageId.toString(),
        },
      );
      form.patchValue(transformedRegionsData);
    } else {
      let /** @type {?} */ tmp = this.transformReactiveToJSON(group, additionalData, isCookie);
      tmp = this.transformObject.formModel(sliderData, tmp, 'second-loan');
      form = this.fb.group(tmp);
    }

    this.formData = ( /** @type {?} */((<any>Object))).assign(
      form.value,
      formData,
      transformedRegionsData,
    );

    form5 = this.cookieService.get('TNK-FORM5');

    if (this.formData.birthCityId) {
      this.getBirthCity(this.formData.birthCityId);
    }
    this.setStore({ form: form, cookiesData: this.formData });

    // if(this.formData.oldVal_gender) {
    // 	this.setStore({ oldVal_gender: this.formData.oldVal_gender });
    // }

    // if(this.formData.oldVal_dob) {
    // 	this.setStore({ oldVal_dob: this.formData.oldVal_dob });
    // }

    setTimeout(() => {
      /*
       * validate base on job type
       */
      this.validateJob(this.store.form.value.income_jobType, 'init');

      /*
       * validate base on customer marital status
       */
      if (this.formData.maritalStatusType === 'Married') {
        this.spouseValidity(this.formData.maritalStatusType);
      }

      /*
       * different residential type have different validation requirement
       */
      if (
        this.formData.housing_residentialType === 'BoardingHouse' ||
        this.formData.housing_residentialType === 'Contract'
      ) {
        this.validityCost(this.formData.housing_residentialType);
      }

      /*
       * to validate housing_numberOfPeople
       */
      this.validateNumOfPeople();

      this.onChangedValue(this.formData);

      /*
       * check if the bank input value exist in banks[].
       */
      this.store.form.controls.bankName.setValidators([
        checkValInArrayObj(this.store.banks),
      ]);
    }, 500);

    form.valueChanges.subscribe(data => this.onChangedValue(data));
    form.controls['maritalStatusType'].valueChanges.subscribe(data =>
      this.spouseValidity(data),
    );
    form.controls['housing_residentialType'].valueChanges.subscribe(data =>
      this.validityCost(data),
    );
    form.controls['income_jobType'].valueChanges.subscribe(data =>
      this.validateJob(data),
    );
    this.store.form.controls.bankName.updateValueAndValidity();
  }
/**
 * @return {?}
 */
private clearValidatorEntrepreneurField(): void {
    this.store.form.controls.income_businessName.clearValidators();
    this.store.form.controls.income_businessType.clearValidators();
    this.store.form.controls.income_businessAge.clearValidators();
    this.store.form.controls.income_businessIncome.clearValidators();
    this.store.form.controls.income_businessPromotion.clearValidators();
    this.store.form.controls.income_businessPlace.clearValidators();
    this.store.form.controls.income_numberOfEmployees.clearValidators();
  }
/**
 * @return {?}
 */
private updateValueAndValidityEntrepreneurField(): void {
    this.store.form.controls.income_businessName.updateValueAndValidity();
    this.store.form.controls.income_businessType.updateValueAndValidity();
    this.store.form.controls.income_businessAge.updateValueAndValidity();
    this.store.form.controls.income_businessIncome.updateValueAndValidity();
    this.store.form.controls.income_businessPromotion.updateValueAndValidity();
    this.store.form.controls.income_businessPlace.updateValueAndValidity();
    this.store.form.controls.income_numberOfEmployees.updateValueAndValidity();
  }
/**
 * @param {?} data
 * @param {?=} type
 * @return {?}
 */
private validateJob(data, type?: any) {
    if (
      data !== 'PublicServant' &&
      data !== 'PrivateEmployee' &&
      data !== 'MilitaryPolice' &&
      data !== 'Entrepreneur' &&
      data !== 'Other'
    ) {
      this.store.form.controls.income_monthlyIncome.clearValidators();
      this.store.form.controls.income_monthlyIncome.updateValueAndValidity();

      this.clearValidatorEntrepreneurField();
      this.updateValueAndValidityEntrepreneurField();

      this.store.form.patchValue({
        income_employmentStatus: 'Contract',
        income_employerName: 'none',
        income_workPosition: 'Contract',
        income_monthlyIncome: '0',
        income_previousIncome: '0',
        income_loanPurposeOfWorkingCapital: '',
        income_businessName: '',
        income_businessType: '0',
        income_businessAge: '0',
        income_businessIncome: '',
        income_businessPromotion: '0',
        income_onlineChannel: '',
        income_businessPlace: '0',
        income_rentalCosts: '',
        income_numberOfEmployees: '0',
        income_helpedByFamilyMembers: '',
      });
    } else if (data === 'Entrepreneur') {
      this.store.form.controls.income_monthlyIncome.clearValidators();
      this.store.form.controls.income_monthlyIncome.updateValueAndValidity();

      this.store.form.patchValue({
        income_employmentStatus: 'Contract',
        income_employerName: 'none',
        income_workPosition: 'Contract',
        income_monthlyIncome: '0',
        income_previousIncome: '0',
      });

      this.store.form.controls.income_businessName.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(80),
        NoSpaceValidator(),
        NoDashValidator(),
      ]);
      this.store.form.controls.income_businessAge.setValidators([
        RequiredSelectValidator(),
      ]);
      this.store.form.controls.income_businessType.setValidators([
        RequiredSelectValidator(),
      ]);
      this.store.form.controls.income_businessIncome.setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.min(1000000),
        Validators.max(1000000000),
      ]);
      this.store.form.controls.income_businessPromotion.setValidators([
        RequiredSelectValidator(),
      ]);
      this.store.form.controls.income_businessPlace.setValidators([
        RequiredSelectValidator(),
      ]);
      this.store.form.controls.income_numberOfEmployees.setValidators([
        RequiredSelectValidator(),
      ]);

      this.updateValueAndValidityEntrepreneurField();

      if (type === 'init') {
        if (this.store.form.controls.income_businessName.value) {
          this.store.form.patchValue({
            income_businessName: this.formData.income_businessName,
          });
        }
        if (this.store.form.controls.income_loanPurposeOfWorkingCapital.value) {
          this.store.form.patchValue({
            income_loanPurposeOfWorkingCapital: this.store.form.controls
              .income_loanPurposeOfWorkingCapital.value,
          });
        }
        if (this.store.form.controls.income_businessType.value !== '0') {
          this.store.form.patchValue({
            income_businessType: this.store.form.controls.income_businessType
              .value,
          });
        }
        if (this.store.form.controls.income_businessAge.value !== '0') {
          this.store.form.patchValue({
            income_businessAge: this.store.form.controls.income_businessAge
              .value,
          });
        }
        if (this.store.form.controls.income_businessIncome.value) {
          this.store.form.patchValue({
            income_businessIncome: this.store.form.controls
              .income_businessIncome.value,
          });
        }
        if (this.store.form.controls.income_businessPromotion.value !== '0') {
          this.store.form.patchValue({
            income_businessPromotion: this.store.form.controls
              .income_businessPromotion.value,
          });
        }
        if (this.store.form.controls.income_onlineChannel.value) {
          this.store.form.patchValue({
            income_onlineChannel: this.store.form.controls.income_onlineChannel
              .value,
          });
        }
        if (this.store.form.controls.income_businessPlace.value !== '0') {
          this.store.form.patchValue({
            income_businessPlace: this.store.form.controls.income_businessPlace
              .value,
          });
        }
        if (this.store.form.controls.income_rentalCosts.value) {
          this.store.form.patchValue({
            income_rentalCosts: this.store.form.controls.income_rentalCosts
              .value,
          });
        }
        if (this.store.form.controls.income_numberOfEmployees.value !== '0') {
          this.store.form.patchValue({
            income_numberOfEmployees: this.store.form.controls
              .income_numberOfEmployees.value,
          });
        }
        if (this.store.form.controls.income_helpedByFamilyMembers.value) {
          this.store.form.patchValue({
            income_helpedByFamilyMembers: this.store.form.controls
              .income_helpedByFamilyMembers.value,
          });
        }
      }
    } else {
      this.clearValidatorEntrepreneurField();
      this.updateValueAndValidityEntrepreneurField();

      this.store.form.patchValue({
        income_loanPurposeOfWorkingCapital: '',
        income_businessName: '',
        income_businessType: '0',
        income_businessAge: '0',
        income_businessIncome: '',
        income_businessPromotion: '0',
        income_onlineChannel: '',
        income_businessPlace: '0',
        income_rentalCosts: '',
        income_numberOfEmployees: '0',
        income_helpedByFamilyMembers: '',
      });

      this.store.form.controls.income_monthlyIncome.setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.min(1000000),
        Validators.max(1000000000),
      ]);
      this.store.form.controls.income_monthlyIncome.updateValueAndValidity();

      if (type === 'init') {
        if (this.store.form.controls.income_employmentStatus.value !== '0') {
          this.store.form.patchValue({
            income_employmentStatus: this.formData.income_employmentStatus,
          });
        }

        if (this.store.form.controls.income_employerName.value) {
          this.store.form.patchValue({
            income_employerName: this.formData.income_employerName,
          });
        }

        if (this.store.form.controls.income_workPosition.value !== '0') {
          this.store.form.patchValue({
            income_workPosition: this.formData.income_workPosition,
          });
        }

        if (this.store.form.controls.income_monthlyIncome.value) {
          this.store.form.patchValue({
            income_monthlyIncome: this.formData.income_monthlyIncome,
          });
        }

        if (this.store.form.controls.income_previousIncome.value) {
          this.store.form.patchValue({
            income_previousIncome: this.formData.income_previousIncome,
          });
        }
      } else {
        this.store.form.patchValue({
          income_employmentStatus: '0',
          income_employerName: '',
          income_workPosition: '0',
          income_monthlyIncome: '',
          income_previousIncome: '',
          income_loanPurposeOfWorkingCapital: '',
          income_businessName: '',
          income_businessType: '0',
          income_businessAge: '0',
          income_businessIncome: '',
          income_businessPromotion: '0',
          income_onlineChannel: '',
          income_businessPlace: '0',
          income_rentalCosts: '',
          income_numberOfEmployees: '0',
          income_helpedByFamilyMembers: '',
        });
      }
    }
  }
/**
 * @param {?} data
 * @return {?}
 */
private validityCost(data) {
    if (data === 'BoardingHouse' || data === 'Contract') {
      this.store.form.controls['housing_monthlyCost'].setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.min(100000),
        Validators.max(1000000000),
      ]);
      this.store.form.controls['housing_expenseCost'].setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.min(100000),
        Validators.max(1000000000),
      ]);
      this.store.form.controls['housing_monthlyCost'].updateValueAndValidity();
      this.store.form.controls['housing_expenseCost'].updateValueAndValidity();

      this.onChangedValue(this.store.form.value);
    } else {
      this.store.form.controls['housing_monthlyCost'].setValidators([
        Validators.required,
        NumericalValidator(),
      ]);
      this.store.form.controls['housing_expenseCost'].setValidators([
        Validators.required,
        NumericalValidator(),
      ]);
      this.store.form.controls['housing_monthlyCost'].updateValueAndValidity();
      this.store.form.controls['housing_expenseCost'].updateValueAndValidity();

      this.onChangedValue(this.store.form.value);
    }
  }
/**
 * @return {?}
 */
private validateNumOfPeople() {
    this.store.form.controls['housing_numberOfPeople'].setValidators([
      Validators.required,
      NumericalValidator(),
      Validators.max(20),
      Validators.min(1),
    ]);
  }
/**
 * @param {?} val
 * @return {?}
 */
private spouseValidity(val) {
    if (val === 'Married') {
      this.store.form.controls['spouse_pin'].setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.minLength(16),
        Validators.maxLength(16),
      ]);
      this.store.form.controls['spouse_name'].setValidators([
        Validators.required,
        Validators.maxLength(50),
        NoNumericValidator(),
        NoSpaceValidator(),
      ]);
      this.store.form.controls['spouse_dateOfBirth'].setValidators([
        Validators.required,
      ]);
      this.store.form.controls['spouse_splitAssetAgreement'].setValidators([
        Validators.required,
      ]);
      this.store.form.controls['spouse_pin'].updateValueAndValidity();
      this.store.form.controls['spouse_name'].updateValueAndValidity();
      this.store.form.controls['spouse_dateOfBirth'].updateValueAndValidity();
      this.store.form.controls[
        'spouse_splitAssetAgreement'
      ].updateValueAndValidity();

      this.onChangedValue(this.store.form.value);
    } else if (val !== 'Married') {
      this.store.form.controls['spouse_pin'].setValidators([
        NumericalValidator(),
        Validators.minLength(16),
        Validators.maxLength(16),
      ]);
      this.store.form.controls['spouse_name'].setValidators([
        Validators.maxLength(50),
      ]);
      this.store.form.controls['spouse_dateOfBirth'].clearValidators();
      this.store.form.controls['spouse_splitAssetAgreement'].clearValidators();
      this.store.form.controls['spouse_pin'].updateValueAndValidity();
      this.store.form.controls['spouse_name'].updateValueAndValidity();
      this.store.form.controls['spouse_dateOfBirth'].updateValueAndValidity();
      this.store.form.controls[
        'spouse_splitAssetAgreement'
      ].updateValueAndValidity();

      const /** @type {?} */ defaultDate = moment()
        .subtract(21, 'years')
        .format('YYYY-MM-DD');

      this.store.form.patchValue({
        spouse_pin: '',
        spouse_name: '',
        spouse_dateOfBirth: defaultDate,
        spouse_splitAssetAgreement: '',
      });

      this.onChangedValue(this.store.form.value);
    }
  }
/**
 * @param {?} data
 * @return {?}
 */
private onNameChanged(data) {
    const /** @type {?} */ name = data ? data.split(/\s+/) : '';

    const /** @type {?} */ cookiesData = this.cookieService.get('TNK-SL-LNDATA')
      ? this.cookieService.get('TNK-SL-LNDATA')
      : {};
    const /** @type {?} */ formValue = ( /** @type {?} */((<any>Object))).assign(cookiesData, this.store.form.value);

    if (name.length > 0) {
      formValue.firstName = name[0];
      name.splice(0, 1);

      for (let /** @type {?} */ i = 0; i < name.length; i++) {
        if (name[i] === '') {
          name.splice(i, 1);
          i--;
        }
      }

      formValue.lastName = name.length > 0 ? name.join(' ') : '-';

      this.store.form.patchValue({
        ktpName: `${formValue.firstName} ${formValue.lastName}`,
      });
    }
  }
/**
 * @param {?} data
 * @return {?}
 */
private onChangedValue(data) {
    if (!this.store.form) {
      return;
    }
    const /** @type {?} */ form = this.store.form;
    const /** @type {?} */ errors = this.store.errors;

    this.setStore({
      disabledNextButton: this.stepValidator(this.store.step),
    });
    const /** @type {?} */ cookiesData = this.cookieService.get('TNK-SL-LNDATA')
      ? this.cookieService.get('TNK-SL-LNDATA')
      : {};

    const /** @type {?} */ formValue = ( /** @type {?} */((<any>Object))).assign(cookiesData, data);

    this.cookieService.set('TNK-SL-LNDATA', formValue);

    if (data.bankName !== '') {
      this.findBankByCode(data.bankName);
    }

    for (const /** @type {?} */ field in this.store.errors) {
      if (this.store.errors.hasOwnProperty(field)) {
        const /** @type {?} */ control = form.get(field);
        this.store.errors[field] = '';

        this.setStore({ errors: this.store.errors });

        if (control && control.dirty && !control.valid) {
          for (const /** @type {?} */ key in control.errors) {
            if (this.store.errors.hasOwnProperty(field)) {
              errors[field] = `${this.validationMessages[field][key]} `;
              this.setStore({ errors: errors });
            }
          }
        } else if (
          control &&
          control.invalid &&
          control.value !== '' &&
          control.value !== '0'
        ) {
          for (const /** @type {?} */ key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              errors[field] = `${this.validationMessages[field][key]} `;
              this.setStore({ errors: errors });
            }
          }
        }
      }
    }
  }
/**
 * @param {?} spousePin
 * @return {?}
 */
public spouseDob(spousePin) {
    const { ktpBirthday } = this.transformKtpData(spousePin);

    this.setStore({
      spouse_dateOfBirth: ktpBirthday,
    });

    this.store.form.patchValue({
      spouse_dateOfBirth: ktpBirthday,
    });
  }
/**
 * @param {?} value
 * @param {?} type
 * @return {?}
 */
public setBirthDate(value, type) {
    if (!type) {
      this.store.form.patchValue({ dateOfBirth: value });
    } else {
      this.store.form.patchValue({ spouse_dateOfBirth: value });
    }
  }
/**
 * @param {?} code
 * @return {?}
 */
public findBankByCode(code: string) {
    _.find(this.store.banks, (item, index) => {
      if (item.code === code) {
        this.setStore({ selectedBankName: item.name });
      }
    });
  }
/**
 * @return {?}
 */
public confirmEditReview() {
    this.setStore({ editReviewForm: !this.store.editReviewForm });

    if (!this.store.form.controls.loanAmount.value) {
      this.store.form.patchValue({ loanAmount: 10000000 });
    }

    if (!this.store.form.controls.loanPeriod.value) {
      this.store.form.patchValue({ loanPeriod: 12 });
    }
  }
/**
 * @param {?} type
 * @param {?} data
 * @return {?}
 */
public handleLoanSlider(type, data) {
    if (type === 'amount_period') {
      this.store.form.patchValue({
        loanAmount: data.loanAmount,
        loanPeriod: data.loanPeriod,
      });

      setTimeout(() => {
        this.setStore({
          disabledNextButton: this.stepValidator(this.store.step),
        });
      }, 50);
    } else if (type === 'purpose') {
      this.store.form.patchValue({
        loanPurpose: data,
      });

      setTimeout(() => {
        this.setStore({
          disabledNextButton: this.stepValidator(this.store.step),
        });
      }, 50);
    }
  }
/**
 * @param {?} evt
 * @return {?}
 */
public agreeToFormPrivacy(evt) {
    this.store.form.patchValue({ agreedForm: evt.target.checked });

    setTimeout(() => {
      this.setStore({
        disabledNextButton: this.stepValidator(this.store.step),
      });
    }, 50);
  }
/**
 * @param {?} data
 * @param {?} additionalData
 * @param {?=} isCookie
 * @return {?}
 */
private transformReactiveToJSON(data, additionalData, isCookie?: boolean) {
    const /** @type {?} */ modelObject = {
      contactAddress: {
        street: '',
        buildingNumber: '',
        flatNumber: '',
        village: '',
        district: '',
        rt: '',
        rw: '',
        province: '',
        postalCode: '',
        city: '',
      },
      domicileAddress: '',
      domicileAddressObj: {
        street: '',
        buildingNumber: '',
        buildingType: '',
        flatNumber: '',
        village: '',
        district: '',
        rt: '',
        rw: '',
        province: '',
        postalCode: '',
        city: '',
      },
      housing: {
        residentialType: '',
        propertyType: '',
        yearMovedIn: '',
        monthMovedIn: '',
        numberOfPeople: '',
        monthlyResidenceCost: '',
        homePhone: '',
        electricityAndWaterCost: '',
      },

      educationType: '',
      maritalStatusType: '',
      income: {
        jobType: '',
        taxId: '',
        employmentStatus: '',
        employerName: '',
        yearSince: '',
        monthSince: '',
        workPosition: '',
        employeeId: '',
        monthlyIncome: '',
        previousIncome: '',
      },
      pin: '',
      gender: '',
      dateOfBirth: '',
      birthCityId: '',
      birthCityName: '',
      birthProvinceId: '',
      birthProvinceName: '',
      otherLoans: [],
      referralCode: '',
      documentValidDate: '',
      mothersName: '',
      mothersPhone: '',
      partnerPhone: '',
      familyCardNumber: '',
      religion: '',
      citizenship: '',
      dependants: '',
      emailIsOwn: 'Personal',
      account: {
        bankName: '',
        accountNumber: '',
        accountType: 'Personal',
      },
      personalReference: {
        name: '',
        relationship: '',
        address: '',
        zip: '',
        city: '',
        homePhone: '',
        mobilePhone: '',
      },
      loanPurposeType: '',
      mediasource: 'NotDefined',
      vehicles: [],
      spouse: {
        pin: '',
        name: '',
        dateOfBirth: '',
        splitAssetAgreement: '',
      },
      loanAmount: '',
      loanPeriodInMonths: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      mobilePhoneNumber: '',
      contractStatus: 'Not signed',
      pageTrack: [],
      browserName: '',
      customerIP: '',
      documents: [],
      additionalParameters: {
        device: '',
        os: '',
        browser: '',
        sendFrom: 'second loan',
        platform: '',
        versionName: 'C08',
      },
    };

    const /** @type {?} */ transformedObject: any = Object.assign({}, modelObject);

    transformedObject.loanAmount = data.loanAmount;
    transformedObject.loanPeriodInMonths = data.loanPeriod;
    transformedObject.loanPurposeType = data.loanPurpose;
    transformedObject.mediasource = data.mediasource
      ? data.mediasource
      : 'NotDefined';

    transformedObject.personalReference = {
      name: data.personalReference_name,
      relationship: '',
      address: data.personalReference_address,
      zip: '',
      city: '',
      homePhone: data.personalReference_mobilePhone,
      mobilePhone: data.personalReference_mobilePhone,
    };

    transformedObject.account = {
      bankName: data.bankName,
      accountNumber: data.bankAccount,
      accountType: 'Personal',
    };

    if (data.income_jobType === 'Entrepreneur') {
      transformedObject.income = {
        jobType: data.income_jobType,
        businessType: data.income_businessType,
        loanPurposeOfWorkingCapital:
          data.loanPurpose === 'VentureCapital'
            ? data.income_loanPurposeOfWorkingCapital
            : '',
        businessName: data.income_businessName,
        businessAge: data.income_businessAge,
        businessIncomeShow: data.income_businessIncome_show,
        businessIncome: parseInt(data.income_businessIncome),
        businessPromotion: data.income_businessPromotion,
        onlineChannel:
          data.income_businessPromotion !==
          BUSINESS_PROMOTION_ENTREPRENEUR.MOSTLY_OFFLINE
            ? data.income_onlineChannel
            : '',
        businessPlace: data.income_businessPlace,
        numberOfEmployees: data.income_numberOfEmployees,
        helpedByFamilyMembers:
          data.income_numberOfEmployees ===
          NUMBER_OF_EMPLOYEES_ENTREPRENEUR.HELPED_BY_FAMILY_MEMBERS
            ? data.income_helpedByFamilyMembers
            : '',
        rentalCostsShow: data.income_rentalCosts_show,
        rentalCosts:
          data.income_businessPlace === BUSINESS_PLACE_ENTREPRENEUR.RENT_RUKO
            ? parseInt(data.income_rentalCosts)
            : '',
      };
    } else {
      transformedObject.income = {
        jobType: data.income_jobType,
        taxId: '0',
        employmentStatus: data.income_employmentStatus,
        employerName: data.income_employerName,
        yearSince: '',
        monthSince: '',
        workPosition: data.income_workPosition,
        employeeId: '0',
        monthlyIncomeShow: data.income_monthlyIncome_show,
        monthlyIncome: parseInt(data.income_monthlyIncome),
        previousIncomeShow: data.income_previousIncome_show,
        previousIncome: parseInt(data.income_previousIncome),
      };
    }

    transformedObject.domicileAddress = data.domicileAddress_street;
    transformedObject.dependants = data.dependants;
    transformedObject.citizenship = data.citizenship;
    transformedObject.religion = data.religion;
    transformedObject.mothersName = data.mothersName;
    transformedObject.birthCityId = data.birthCityId;
    transformedObject.dateOfBirth = data.dateOfBirth;
    transformedObject.pin = data.pin;
    transformedObject.gender = data.gender;
    transformedObject.maritalStatusType = data.maritalStatusType;
    transformedObject.educationType = data.educationType;
    transformedObject.housing = {
      residentialType: data.housing_residentialType,
      propertyType: data.housing_propertyType,
      yearMovedIn: '',
      monthMovedIn: '',
      numberOfPeople: data.housing_numberOfPeople,
      monthlyResidenceCost: parseInt(data.housing_monthlyCost),
      monthlyResidenceCostShow: data.housing_monthlyCost_show,
      homePhone: '',
      electricityAndWaterCost: parseInt(data.housing_expenseCost),
      electricityAndWaterCostShow: data.housing_expenseCost_show,
    };

    transformedObject.domicileAddressObj = {
      street: data.domicileAddress_street,
      buildingNumber: data.domicileAddress_bldNumber,
      buildingType: data.domicileAddress_buildingType,
      flatNumber: data.domicileAddress_flatNumber,
      rt: data.domicileAddress_rt,
      rw: data.domicileAddress_rw,
      province: isCookie
        ? data.domicileAddress_province
        : this.transformRegionValue(
            data.domicileAddress_province,
            this.store.provinces,
            'province',
            null,
          ),
      city: isCookie
        ? data.domicileAddress_city
        : this.transformRegionValue(
            data.domicileAddress_city,
            this.store.cities,
            'city',
            null,
          ),
      district: isCookie
        ? data.domicileAddress_district
        : this.transformRegionValue(
            data.domicileAddress_district,
            this.store.districts,
            'district',
            null,
          ),
      village: isCookie
        ? data.domicileAddress_village
        : this.transformRegionValue(
            data.domicileAddress_village,
            this.store.villages,
            'village',
            null,
          ),
      postalCode: data.domicileAddress_postalCode,
    };

    transformedObject.contactAddress = {
      street: data.contactAddress_street,
      buildingNumber: data.contactAddress_bldNumber,
      flatNumber: data.contactAddress_flatNumber,
      rt: data.contactAddress_rt,
      rw: data.contactAddress_rw,
      province: isCookie
        ? data.contactAddress_province
        : this.transformRegionValue(
            data.contactAddress_province,
            this.store.provinces,
            'province',
            null,
          ),
      city: isCookie
        ? data.contactAddress_city
        : this.transformRegionValue(
            data.contactAddress_city,
            this.store.citiesContact,
            'city',
            null,
          ),
      district: isCookie
        ? data.contactAddress_district
        : this.transformRegionValue(
            data.contactAddress_district,
            this.store.districtsContact,
            'district',
            null,
          ),
      village: isCookie
        ? data.contactAddress_village
        : this.transformRegionValue(
            data.contactAddress_village,
            this.store.villagesContact,
            'village',
            null,
          ),
      postalCode: data.contactAddress_postalCode,
    };

    if (data.referralCode) {
      transformedObject.referralCode = data.referralCode;
    } else {
      delete transformedObject.referralCode;
    }

    const /** @type {?} */ refCode = this.cookieService.get('TNK-REF')
      ? this.cookieService.get('TNK-REF')
      : null;

    if (refCode) {
      transformedObject.referralCode = refCode;
    }

    if (data.maritalStatusType === 'Married') {
      transformedObject.spouse = {
        pin: data.spouse_pin,
        name: data.spouse_name,
        dateOfBirth: data.spouse_dateOfBirth,
        splitAssetAgreement: data.spouse_splitAssetAgreement,
      };
    } else {
      delete transformedObject.spouse;
    }

    const /** @type {?} */ name = data.ktpName.split(/\s+/);
    transformedObject.firstName = name[0];
    name.splice(0, 1);

    for (let /** @type {?} */ i = 0; i < name.length; i++) {
      if (name[i] === '') {
        name.splice(i, 1);
        i--;
      }
    }

    transformedObject.lastName = name.length > 0 ? name.join(' ') : '-';
    transformedObject.emailAddress = data.emailAddress;

    const /** @type {?} */ mobilephone = transformPhoneNumber(data.mobilePhoneNumber);
    const /** @type {?} */ referencePhone = transformPhoneNumber(
      data.personalReference_mobilePhone,
    );

    transformedObject.personalReference.mobilePhone = `+62${referencePhone}`;
    transformedObject.personalReference.homePhone = `+62${referencePhone}`;
    transformedObject.mobilePhoneNumber = `+62${mobilephone}`;

    if (additionalData) {
      transformedObject.additionalParameters = {
        device: additionalData.device,
        os: additionalData.os,
        browser: additionalData.browser,
        platform: additionalData.platform,
        sendFrom: 'second loan',
        versionName: 'C08',
      };
    }
    return transformedObject;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
{type: HttpClient, },
{type: ApiConstant, },
{type: Router, },
{type: TransformObjectFormService, },
{type: CookieService, },
{type: AuthTokenService, },
];
}

function TNKAuthLoanFormService_tsickle_Closure_declarations() {
/** @type {?} */
TNKAuthLoanFormService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKAuthLoanFormService.ctorParameters;
/** @type {?} */
TNKAuthLoanFormService.prototype.data;
/** @type {?} */
TNKAuthLoanFormService.prototype.isFraudAttemptAlert;
/** @type {?} */
TNKAuthLoanFormService.prototype.dispatcher;
/** @type {?} */
TNKAuthLoanFormService.prototype.store;
/** @type {?} */
TNKAuthLoanFormService.prototype.obsInitRegions;
/** @type {?} */
TNKAuthLoanFormService.prototype.dispatcherInitRegions;
/** @type {?} */
TNKAuthLoanFormService.prototype.initRegions;
/** @type {?} */
TNKAuthLoanFormService.prototype.formData;
/** @type {?} */
TNKAuthLoanFormService.prototype.contactSameAsKTP;
/** @type {?} */
TNKAuthLoanFormService.prototype.cashtreeRefcodeFormat;
/** @type {?} */
TNKAuthLoanFormService.prototype.currencyOptions;
/** @type {?} */
TNKAuthLoanFormService.prototype.affiliateCookieName;
/** @type {?} */
TNKAuthLoanFormService.prototype.transformKtpData;
/** @type {?} */
TNKAuthLoanFormService.prototype.validationMessages;
/** @type {?} */
TNKAuthLoanFormService.prototype.fb;
/** @type {?} */
TNKAuthLoanFormService.prototype.http;
/** @type {?} */
TNKAuthLoanFormService.prototype.apiConstant;
/** @type {?} */
TNKAuthLoanFormService.prototype.router;
/** @type {?} */
TNKAuthLoanFormService.prototype.transformObject;
/** @type {?} */
TNKAuthLoanFormService.prototype.cookieService;
/** @type {?} */
TNKAuthLoanFormService.prototype.authService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
